document.addEventListener("click", function (evt) {
  const toggler = evt.target.closest(".mobile-view-toggler")
  if (!toggler) return
  const checked = toggler.getAttribute("aria-checked") == "false"
  toggler.setAttribute("aria-checked", checked)
  for (const item of document.querySelectorAll(".grid__item")) {
    item.classList.toggle("small--one-whole", !checked)
    item.classList.toggle("small--one-half", checked)
  }
  const gridClassesElement = document.getElementById("grid_item_width_classes")
  const [replaced, replacement] = checked
    ? ["small--one-whole", "small--one-half"]
    : ["small--one-half", "small--one-whole"]
  gridClassesElement.value = gridClassesElement.value.replace(
    replaced,
    replacement,
  )
})
